import axiosInstance from "./axiosInstance";

export const getAllUsers = async (name = '', skip = 0, limit = 100, status = '') => {
    return await axiosInstance.get(`/user/all`, {
      params: {
        name,
        skip,
        limit,
        status,
      },
    });
  };

export const getDashboardData = async () => {
  return await axiosInstance.get("/user/dashboard");
};
